import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/IngenieriaEnSistemasElectricos/page.js");
